/**
 * Fixed landscape (PROJECT_SPEC.md §10.5, URS-10.5-007). The manifest asks for landscape and is honoured by Android;
 * iOS ignores it, so where the Screen Orientation API refuses to lock (or does not exist) a touch device held upright
 * is covered by this instruction (styled in app.css, shown only for portrait + coarse pointer) until it is turned.
 * Nothing is unmounted, so no entry is lost by turning the device back and forth.
 */
import { useEffect } from "react";

interface OrientationLike {
  lock?: (o: "landscape") => Promise<void>;
}

/** Asks the browser to hold landscape. A refusal (not installed, not fullscreen, iOS) is expected and not an error. */
export async function lockLandscape(orientation: OrientationLike | undefined): Promise<boolean> {
  if (!orientation?.lock) return false;
  try {
    await orientation.lock("landscape");
    return true;
  } catch {
    return false;
  }
}

export function RotateNotice() {
  useEffect(() => {
    void lockLandscape((screen as { orientation?: OrientationLike }).orientation);
  }, []);
  return (
    <div className="rotate-notice" role="alert" data-testid="rotate-notice">
      <span className="material-symbols-outlined" style={{ fontSize: 64 }} aria-hidden="true">
        screen_rotation
      </span>
      <p style={{ margin: 0, fontWeight: 700 }}>Turn the tablet sideways</p>
      <p style={{ margin: 0 }}>
        Corpex EBR is used in landscape. Whatever you were entering is kept; turn the tablet back and carry
        on.
      </p>
    </div>
  );
}
